module.exports = __webpack_public_path__ + "static/media/quote-svgrepo-com.2d0e8a72.svg";